// This file contains functions for JS parsing, used for extracting the value paths of the raw JSONs received from BE.

import JSONAST from "json-to-ast";


export function JSON2HTML(json) {
  let AST = JSONAST(json, { loc: false });

  // Sort inintial AST alphabet.
  let { children = [] } = AST;
  children.sort((a, b) => {
    let rv = 0;
    try {
      let keyA = a.key.value;
      let keyB = b.key.value;

      if (keyA < keyB) {
        rv = -1;
      }
      if (keyA > keyB) {
        rv = 1;
      }
    } catch (error) {
      console.error(error);
    }

    return rv;
  });


  return (
    "<div class='jsonHighlight'>" +
    processAST(AST, "", 0, true, []) +
    "<br/><br/></div>"
  );
}

function padding(level) {
  let str = "";
  for (let i = 0; i < level; i++) {
    str += "  ";
  }
  return str;
}

function markupForCtrChars(chars) {
  if (chars === "\n") {
    return "<br/>";
  } else {
    return "<span class='jsh-ctr'>" + chars + "</span>";
  }
}

function markupForVal(chars, path) {
  path = JSON.stringify(path);
  let cssclass = "jsh-val";
  return (
    "<span class=" +
    cssclass +
    " tabindex='0' data-path=" +
    path +
    ">" +
    chars +
    "</span>"
  );
}

function markupForKey(chars) {
  return "<span class='jsh-key'>" + chars + "</span>";
}

function processAST(AST, str, level, isLast, path) {
  if (AST.type === "Object") {
    level += 1;
    str +=
      markupForCtrChars("\n") +
      padding(level) +
      markupForCtrChars("{") +
      markupForCtrChars("\n");
    AST.children.forEach((child, idx) => {
      let isLast = idx === AST.children.length - 1;
      str = processAST(child, str, level, isLast, path);
    });
    str += markupForCtrChars("\n") + padding(level) + markupForCtrChars("}");
    str += isLast ? "" : markupForCtrChars(",") + markupForCtrChars("\n");
  } else if (AST.type === "Array") {
    level += 1;
    str +=
      markupForCtrChars("\n") +
      padding(level) +
      markupForCtrChars("[") +
      markupForCtrChars("\n");
    AST.children.forEach((child, idx) => {
      let locpath = [...path, idx];
      let isLast = idx === AST.children.length - 1;
      str = processAST(child, str, level + 2, isLast, locpath);
    });
    str += markupForCtrChars("\n") + padding(level) + "]";
    str += isLast ? "" : "," + "\n";
  } else if (AST.type === "Property") {
    path = [...path, AST.key.value];
    str += padding(level + 1) + markupForKey(AST.key.raw) + ": ";
    str = processAST(AST.value, str, level, isLast, path);
  } else if (AST.type === "Literal") {
    str += padding(level) + markupForVal(AST.raw, path);
    //str +=" -> (PATH=" + path + ")"

    str += isLast ? "" : markupForCtrChars("," + "\n");
  } else {
    console.log("type Not yet implemented", AST.type);
  }

  return str;
}

// This function returns a nested value from the given json object,
// according to the provided path array (json stringified), where each element is a key or
// index, stacked in the sequence of nesting
export function pathArray2Val(path, json, noval_str = "Value not reachable") {
  let rv = noval_str;
  try {
    let arr = JSON.parse(path);
    let val = arr.reduce((acc, curr) => {
      return acc[curr];
    }, json);
    rv = val.toString();
  } catch (error) {}
  return rv;
}

// TODO: In ES6 Class packen
